import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IListState, PaginationType } from '@typings/requestPayloads'

export interface IUserListQueryPaginationPayload {
    qeuery?: any
    pagination?: PaginationType
    noSaveInStore?: boolean
    sagaCB?: {
        onSucces: any
    }
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: [],
    pagination: {
        skip: 0,
        hasTotal: true,
        total: 0,
        limit: 10
    },
    errors: null
}

const userListSearchSlice = createSlice({
    name: 'hub/user/list-search',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IUserListQueryPaginationPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            if (action.payload?.noSaveInStore !== true) {
                state.data = action.payload.data
                state.pagination = {
                    ...state.pagination,
                    skip: action.payload.skip,
                    total: action.payload.total
                }
            }
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const userListSearchActions = userListSearchSlice.actions
export default userListSearchSlice.reducer
